<template>
  <div class="page">
    <div class="head">
      <img width="100%" src="../assets/cp-18.jpg" alt="">
      <div class="des">
        <div class="title">{{title}}</div>
        <div class="text">以更简单的方式协同工作，快速获取意想不到的新洞察，并提供<br>改变业务的结果</div>
        <div>
          <Icon style="padding-right: 10px" size="16" type="md-arrow-forward" />联系INCO获取更多信息
        </div>
      </div>
    </div>
    <div class="container" v-for="(item, index) in list" :key="index">
      <div class="product" v-if="item.list.length > 0" @click="goToNewPage('/productionfive')">
        <div class="title">{{item.title}}</div>
        <a href="javascript" @click.prevent="goImage(item.list[0].img)">
          <img width="100%" :src="imageArray[index]" alt="">
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data() {
    return {
      title: '',
      list: {},
	  imageArray:[require('../assets/cp-20.png'),require('../assets/cp-21.png'),require('../assets/cp-22.png')]
    }
  },
  methods: {
    isEmpty(obj) {
      if (typeof obj == 'undefined' || obj == null || obj == '') {
        return true
      } else {
        return false
      }
    },
    goImage(item) {
      if (!this.isEmpty(item)) {
        window.open(item)
      }
    },
  },
  mounted() {
    this.title = this.$route.query.title
    this.list = JSON.parse(window.localStorage.getItem('productJson1'))

    let url1 =
      this.HOST +
      'inconWeb/getMenuListByParentId?parentid=C839903BBE8909FAE05509994F3826F5&moduleOrder=ordernum&contentOrder=ordernum&websiteid=4'
    url1 = this.$getJsonUrl(url1)
    this.$axios.get(url1).then((res) => {
      let data1 = res.data.content.list[1].children[1].children
      let data2 = res.data.content.list[1].children[2].children
      this.list = [...data1, ...data2]
    })
  },
}
</script>

<style scoped lang="less">
.head {
  position: relative;
  .des {
    position: absolute;
    left: 50%;
    bottom: 30px;
    transform: translateX(-50%);
    width: 1000px;
    // max-width: 1200px;
    color: #fff;
    .title {
      font-size: 18px;
      font-weight: 600;
      line-height: 30px;
    }
    .text {
      padding-bottom: 10px;
      font-size: 14px;
      line-height: 20px;
    }
  }
}
.container {
  width: 1000px;
  // max-width: 1200px;
  margin: 0 auto;
  .product {
    position: relative;
    margin-top: 30px;
    padding-bottom: 10px;
    border-bottom: 1px solid #ddd;
    .title {
      position: absolute;
      top: 8px;
    }
    a {
      display: block;
    }
  }
}
</style>